<template>
	<div class="container my-5">
		<div class="columns is-multiline is-justify-content-center">
			<template v-for="(c, i) in types" :key="i">
				<div class="column is-1 game-flag" @click="filterGoodiesByType(c.name)" :class="selectedItem === c.name ? 'active' : ''">
					<div class="game-name">{{ c.name }}</div>
				</div>
			</template>
		</div>
	</div>
	<br />
	<div class="container mt-5">
		<div class="columns is-multiline">
			<add-card v-if="auth.state.isLoggedIn" column-class="column is-2" @click="openAdd"></add-card>
			<template v-for="(g, j) in goodiesPaginated" :key="j">
				<div class="column is-2 is-flex is-align-items-center is-justify-content-center is-relative">
					<Carousel :items-to-show="itemsToShow" :mouse-drag="false">
						<Slide v-for="image in g.image.src" :key="image.id">
							<figure class="image is-3by4" @click="openGameModal(g.image)">
								<img :src="image" :alt="g.image.alt" class="is-relative" />
							</figure>
						</Slide>

						<template #addons>
							<Navigation />
						</template>
					</Carousel>
					<owned-or-not :owned="g.own"></owned-or-not>
					<div class="admin-actions" v-if="g.id && auth.state.isLoggedIn">
						<button class="icon-button" title="Edit" @click.stop="openEdit(g)">
							<i class="fas fa-pen"></i>
						</button>
						<button class="icon-button icon-button-delete" title="Delete" @click.stop="onDelete(g)">
							<i class="fas fa-trash"></i>
						</button>
					</div>
				</div>
			</template>
		</div>
		<empty-hero v-if="goodiesPaginated.length === 0"></empty-hero>

		<game-modal :game="gameModalContent" v-if="showGameModal" @close-modal="showGameModal = false"></game-modal>

		<Transition name="fade">
			<back-to-top v-if="currentPage > 1"></back-to-top>
		</Transition>
	</div>
	<add-goodie-modal :show="showAddModal" :editing-item="editingItem" :on-submit="handleSubmit" @close="onModalClose"></add-goodie-modal>
</template>

<script>
import GOODIES from '@/goodies.js';
import GameModal from '@/components/GameModal.vue';
import EmptyHero from '@/components/EmptyHero.vue';
import OwnedOrNot from '@/components/OwnedOrNot.vue';
import BackToTop from '@/components/BackToTop.vue';
import AddCard from '@/components/AddCard.vue';
import AddGoodieModal from '@/components/AddGoodieModal.vue';
import auth from '@/auth.js';
import customItems from '@/customItems.js';
import { Carousel, Slide, Navigation } from 'vue3-carousel';
export default {
	name: 'GoodiesView',
	props: ['ownFilter'],
	components: { Carousel, Slide, Navigation, GameModal, EmptyHero, OwnedOrNot, BackToTop, AddCard, AddGoodieModal },
	data() {
		return {
			auth,
			types: [
				{ flag: 'https://picsum.photos/200/300', name: 'TM1-2' },
				{ flag: 'https://picsum.photos/200/300', name: 'TM20' },
				{ flag: 'https://picsum.photos/200/300', name: 'TM-Turbo' },
				{ flag: 'https://picsum.photos/200/300', name: 'Shootmania' },
				{ flag: 'https://picsum.photos/200/300', name: 'Zerator' },
				{ flag: 'https://picsum.photos/200/300', name: 'Others' },
			],
			showGameModal: false,
			gameModalContent: null,
			itemsToShow: 1,
			currentPage: 1,
			perPage: 18,
			showAddModal: false,
			editingItem: null,
		};
	},
	computed: {
		selectedItem() {
			return this.$route.params.type || '';
		},
		goodies() {
			return [...customItems.getItems('goodies'), ...GOODIES];
		},
		filteredGoodies() {
			return this.selectedItem ? this.goodies.filter((good) => good.type.includes(this.selectedItem)) : this.goodies;
		},
		goodiesPaginated() {
			let ownFilteredGames = this.ownFilter !== undefined ? this.filteredGoodies.filter((g) => g.own === this.ownFilter) : this.filteredGoodies;
			return ownFilteredGames.slice(0, this.currentPage * this.perPage);
		},
	},
	methods: {
		filterGoodiesByType(g) {
			const c = this.selectedItem === g ? '' : g;
			this.$router.push({ name: 'goodies', params: { type: c || undefined } });
		},
		openGameModal(g) {
			this.gameModalContent = g;
			this.showGameModal = true;
		},
		handleScroll() {
			if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
				this.currentPage++;
			} else if (window.scrollY === 0) {
				this.currentPage = window.innerHeight > 1080 ? 2 : 1;
			}
		},
		openAdd() {
			this.editingItem = null;
			this.showAddModal = true;
		},
		openEdit(item) {
			this.editingItem = item;
			this.showAddModal = true;
		},
		onModalClose() {
			this.showAddModal = false;
			this.editingItem = null;
		},
		async handleSubmit({ isEdit, id, payload }) {
			if (isEdit) {
				return customItems.updateItem('goodies', id, payload);
			}
			return customItems.addItem('goodies', payload);
		},
		async onDelete(item) {
			if (!confirm('Delete this item?')) return;
			const result = await customItems.deleteItem('goodies', item.id);
			if (!result.ok) {
				alert(result.error || 'Could not delete this item.');
			}
		},
	},
	created() {
		this.currentPage = window.innerHeight > 1080 ? 2 : 1;

		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped>
.column {
	background-color: #57462e;
	background-clip: content-box;
}
.image img {
	object-fit: cover !important;
	object-position: center !important;
}
.game-flag {
	background-color: rgb(7, 7, 7);
	height: 75px;
	width: 150px;
	border-radius: 15px;
	position: relative;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.game-flag:hover .game-name,
.game-flag.active .game-name {
	color: rgb(72, 199, 142);
	font-weight: bold;
}
.admin-actions {
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 20;
	display: flex;
	gap: 6px;
}
.icon-button {
	width: 26px;
	height: 26px;
	padding: 0;
	margin: 0;
	border: none;
	border-radius: 50%;
	background-color: rgba(0, 0, 0, 0.6);
	color: white;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.7rem;
}
.icon-button:hover {
	background-color: #48c78e;
	color: #131417;
}
.icon-button-delete:hover {
	background-color: #f14668;
	color: white;
}
</style>
